import { Headset, Phone, PhoneCall, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const CONTACTS = [
  {
    label: "Guérite",
    description: "Poste de sécurité",
    number: "13 90",
    icon: ShieldCheck,
  },
  {
    label: "Support",
    description: "Assistance plateforme",
    number: "30 30",
    icon: Headset,
  },
] as const;

export function ContactButton() {
  return (
    <div
      className="fixed bottom-5 z-40 sm:bottom-6"
      style={{ right: "var(--hawk-content-edge-right, 1.25rem)" }}
    >
      <Popover>
        <TooltipProvider delayDuration={150}>
          <Tooltip>
            <TooltipTrigger asChild>
              <PopoverTrigger asChild>
                <Button
                  type="button"
                  size="icon"
                  aria-label="Afficher les contacts utiles"
                  className="size-12 rounded border border-white/15 bg-[#171714] text-white shadow-lg shadow-black/15 hover:border-[#b8860b]/55 hover:bg-[#25251f] focus-visible:ring-[#b8860b]"
                >
                  <PhoneCall className="size-5" aria-hidden="true" />
                </Button>
              </PopoverTrigger>
            </TooltipTrigger>
            <TooltipContent side="left">Contact utile</TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <PopoverContent
          side="top"
          align="end"
          sideOffset={14}
          aria-label="Contacts utiles"
          className="w-[min(21rem,calc(100vw-2rem))] origin-[var(--radix-popover-content-transform-origin)] overflow-hidden rounded border-white/10 bg-[#1a1a1a] p-0 text-white shadow-[0_24px_70px_rgba(23,23,20,0.48)] data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:slide-out-to-bottom-2 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-bottom-2 data-[state=open]:zoom-in-95 motion-reduce:animate-none"
        >
          <div className="border-b border-white/10 px-5 py-4">
            <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.28em] text-amber-300">
              <Phone className="h-3.5 w-3.5" aria-hidden="true" />
              Contacts utiles
            </div>
            <p className="mt-1.5 text-sm text-white/55">
              Appelez directement le service dont vous avez besoin.
            </p>
          </div>

          <div className="grid gap-2 p-3">
            {CONTACTS.map((contact) => {
              const Icon = contact.icon;

              return (
                <div
                  key={contact.label}
                  className="flex items-center gap-3 rounded border border-white/10 bg-white/[0.035] px-3 py-3"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded border border-amber-400/20 bg-amber-400/10 text-amber-300">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-semibold text-white/90">{contact.label}</span>
                    <span className="block text-xs text-white/40">{contact.description}</span>
                  </span>
                  <span className="font-mono text-lg font-semibold tracking-[0.08em] text-amber-300">
                    {contact.number}
                  </span>
                </div>
              );
            })}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
